<template>
    <main role="main" class="ep-v2">
        <portal to="ariane">
            <div class="tbv2-page-title">
                <router-link :to="postLink" class="tbv2-crumb">{{ $t('menu.tickets.ticket') || 'Ticket' }}</router-link>
                <span class="tbv2-sep">/</span>
                <span class="tbv2-current">{{ $t('wizard.editForm') }}</span>
            </div>
        </portal>

        <div v-if="loading" class="ep-loading">
            <i class="fal fa-spinner-third fa-spin"></i>
        </div>

        <custom-wizard v-else :form-id="formId" :post-id="postId" :is-backoffice="true" />
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import CustomWizard from '@/components/Wizard/CustomWizard.vue'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'EditPost',
    components: { CustomWizard },
    data() {
        return {
            loading: true,
            postId: parseInt(this.$route.params.postId),
            formId: null
        }
    },
    computed: {
        ...mapState('post', {
            post: (state) => state.post
        }),
        postLink() {
            return this.postId ? `/posts/${this.postId}` : '/posts'
        }
    },
    methods: {
        ...mapActions('post', ['getPost'])
    },
    async created() {
        try {
            const result = await this.getPost(this.postId)
            this.formId = result.data.post.form_id
        } catch (e) {
            this.$store.dispatch('dispatchError', e)
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        this.$store.commit('post/setPost', null)
        this.$store.dispatch('map/reset')
    }
}
</script>

<style scoped>
.ep-v2 {
    width: 100%;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.tbv2-crumb {
    color: var(--v2-text-3);
    text-decoration: none !important;
    font-weight: var(--v2-font-weight-medium);
    transition: color var(--v2-transition-fast);
}

.tbv2-crumb:hover {
    color: var(--v2-primary);
}

.tbv2-sep {
    color: var(--v2-text-4);
}

.tbv2-current {
    color: var(--v2-text-1);
}

.ep-loading {
    display: flex;
    justify-content: center;
    padding: var(--v2-space-6);
    color: var(--v2-text-3);
    font-size: 1.5rem;
}
</style>
